import { defineComponent as c, computed as l, createBlock as f, openBlock as p, resolveDynamicComponent as g, mergeProps as L, toHandlers as A } from "vue";
import { usePropsValidation as h } from "../../composables/usePropsValidation.js";
import { tw as n } from "../../utils/tailwind.js";
import B from "./components/DocumentDefault.vue2.js";
import _ from "./components/DocumentDefaultSmall.vue2.js";
import w from "./components/DocumentError.vue2.js";
import D from "./components/DocumentErrorSmall.vue2.js";
import v from "./components/DocumentLoading.vue2.js";
import C from "./components/DocumentLoadingSmall.vue2.js";
const N = /* @__PURE__ */ c({
  name: "RevDocument",
  __name: "Document",
  props: {
    name: { default: "" },
    errorMessage: { default: "" },
    url: { default: "" },
    deletable: { type: Boolean },
    status: { default: "default" },
    thumbnail: { type: Boolean, default: !1 },
    size: { default: "large" },
    downloadButtonAriaLabel: { default: "" },
    deleteButtonAriaLabel: { default: "" },
    loadingAriaLabel: { default: "" }
  },
  emits: ["delete"],
  setup(t, { emit: r }) {
    const e = t, m = r;
    h({
      'Component in "small" `size` needs a `thumbnail` for the image': () => e.size === "small" && !e.thumbnail,
      "Component with `thumbnail` needs an image `url` to be displayed. Only image documents are allowed to have a thumbnail.": () => !e.url && e.thumbnail
    });
    const i = (a) => ({
      large: B,
      small: _
    })[a], u = (a) => ({
      large: v,
      small: C
    })[a], d = (a) => ({
      large: w,
      small: D
    })[a], o = l(
      () => ({
        default: i(e.size),
        loading: u(e.size),
        error: d(e.size)
      })[e.status]
    ), s = l(() => ({
      DocumentDefault: {
        name: e.name,
        deletable: e.deletable,
        url: e.url,
        thumbnail: e.thumbnail,
        downloadButtonAriaLabel: e.downloadButtonAriaLabel,
        deleteButtonAriaLabel: e.deleteButtonAriaLabel
      },
      DocumentDefaultSmall: {
        name: e.name,
        deletable: e.deletable,
        url: e.url,
        thumbnail: e.thumbnail,
        downloadButtonAriaLabel: e.downloadButtonAriaLabel,
        deleteButtonAriaLabel: e.deleteButtonAriaLabel
      },
      DocumentLoading: {
        loadingAriaLabel: e.loadingAriaLabel
      },
      DocumentLoadingSmall: {
        loadingAriaLabel: e.loadingAriaLabel
      },
      DocumentError: {
        name: e.name,
        errorMessage: e.errorMessage,
        deletable: e.deletable,
        deleteButtonAriaLabel: e.deleteButtonAriaLabel
      },
      DocumentErrorSmall: {
        name: e.name,
        errorMessage: e.errorMessage,
        deletable: e.deletable,
        url: e.url,
        deleteButtonAriaLabel: e.deleteButtonAriaLabel
      }
    })), b = l(() => [
      n`bg-float-default-low shadow-short rounded-sm max-w-448 transition-shadow hover:shadow-long`,
      e.status !== "error" && n`border-static-default-mid`
    ]);
    return (a, $) => (p(), f(g(o.value), L(s.value[`${o.value.name}`], {
      class: b.value,
      "data-test": `document-${t.name}`,
      name: t.name
    }, A({
      delete: () => m("delete")
    })), null, 16, ["class", "data-test", "name"]));
  }
});
export {
  N as default
};
